/* eslint-disable @calm/react-intl/missing-formatted-message */

import {
	BoldText,
	LastUpdate,
	LastUpdateDate,
	LegalText,
	PatentContentBlock,
	PatentItem,
	PatentList,
	PatentPageContainer,
	PatentTitle,
	ReferencedTitle,
} from './styles';

const PatentsPage: React.FC = () => (
	<PatentPageContainer>
		<PatentContentBlock>
			<PatentTitle>Virtual Patent Marking</PatentTitle>
			<LegalText>
				This web page is provided to satisfy the virtual patent marking provisions of 35 U.S.C. § 287 and
				serves as notice under that statute. Certain video streaming services are licensed under U.S. Patent
				Nos. 8,595,779, 8,752,101, 9,769,427, and 8,909,809.
			</LegalText>

			<ReferencedTitle>Referenced U.S. Patents</ReferencedTitle>
			<PatentList>
				<PatentItem>U.S. Patent No. 8,595,779</PatentItem>
				<PatentItem>U.S. Patent No. 8,752,101</PatentItem>
				<PatentItem>U.S. Patent No. 9,769,427</PatentItem>
				<PatentItem>U.S. Patent No. 8,909,809</PatentItem>
			</PatentList>
			<LastUpdate>
				This page reflects the current status as of the last update and will be revised as required by law.
			</LastUpdate>
			<LastUpdateDate>
				Last updated: <BoldText> January 7, 2025 </BoldText>{' '}
			</LastUpdateDate>
		</PatentContentBlock>
	</PatentPageContainer>
);

export default PatentsPage;
